const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcademyLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 653.75 118.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Academy Sports + Outdoors logo - Brandlogos.net") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    d: "M220.7,435a3.79,3.79,0,0,0,4,2.66c.8,0,2.66-.27,2.66-1.33,0-1.33-1.6-1.6-2.66-1.86-4.26-.8-9.32-1.86-9.32-7.19a7,7,0,0,1,2.93-5.59,10.92,10.92,0,0,1,6.39-1.6c4,0,7.73,1.6,9.06,5.59l-5.59,1.6c-.53-1.6-1.86-2.13-3.73-2.13-.8,0-2.13.27-2.13,1.33s1.6,1.33,2.4,1.6a29,29,0,0,1,6.39,1.86,6,6,0,0,1,3.2,5.59c0,5.33-5.33,7.46-9.86,7.46-4.8,0-8.79-1.86-10.12-6.93Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.6,442.48h-6.93V420.1h9.06a14.6,14.6,0,0,1,6.66,1.07,6.68,6.68,0,0,1,3.2,5.86,7.26,7.26,0,0,1-2.4,5.59,9.83,9.83,0,0,1-6.13,1.86H251.6Zm1.86-12.79c1.6,0,3.46,0,3.46-2.13,0-1.86-1.6-2.13-3.2-2.13H251.6v4.26Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.22,431.55c0,6.39-4,11.46-10.66,11.46s-10.66-5.06-10.66-11.46c0-6.66,4-11.46,10.66-11.46C290.49,419.83,294.22,424.63,294.22,431.55Zm-14.12,0c0,2.13.27,6.39,3.46,6.39s3.46-4.26,3.46-6.39-.27-6.66-3.46-6.66C280.64,424.89,280.1,429.16,280.1,431.55Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.33,442.48l-3.2-8.52H311v8.52h-6.93V420.1h11.46a11.77,11.77,0,0,1,5.86,1.33,5.92,5.92,0,0,1,2.66,5.33,5.77,5.77,0,0,1-4,5.86l4,9.86Zm-2.93-13.32c1.6,0,3.2-.27,3.2-2.13a1.78,1.78,0,0,0-1.07-1.86,4.53,4.53,0,0,0-1.86-.27H311v4.26Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    d: "M343.51,442.48h-6.66v-17h-4.8V420.1h15.72v5.33h-4.53v17Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_3",
    "data-name": "<Path>",
    d: "M362.69,435a3.79,3.79,0,0,0,4,2.66c.8,0,2.66-.27,2.66-1.33,0-1.33-1.86-1.6-2.66-1.86-4.26-.8-9.32-1.86-9.32-7.19a7,7,0,0,1,2.93-5.59,10.92,10.92,0,0,1,6.39-1.6c4,0,7.73,1.6,9.06,5.59l-5.59,1.6c-.53-1.6-1.86-2.13-3.73-2.13-.8,0-2.13.27-2.13,1.33s1.6,1.33,2.4,1.6a29,29,0,0,1,6.39,1.86,6,6,0,0,1,3.2,5.59c0,5.33-5.33,7.46-9.86,7.46-4.8,0-8.79-1.86-10.12-6.93Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_4",
    "data-name": "<Path>",
    d: "M392.79,421.43h5.86v6.93h6.93v5.86h-6.93v6.93h-5.86v-6.93h-6.93v-5.86h6.93Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#0556a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.08,431.55c0,6.39-4,11.46-10.66,11.46s-10.66-5.06-10.66-11.46c0-6.66,4-11.46,10.66-11.46C430.35,419.83,434.08,424.63,434.08,431.55Zm-14.12,0c0,2.13.27,6.39,3.46,6.39s3.46-4.26,3.46-6.39-.27-6.66-3.46-6.66C420.5,424.89,420,429.16,420,431.55Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_5",
    "data-name": "<Path>",
    d: "M462.06,434.48c0,2.66-.27,4.8-2.4,6.39-1.86,1.6-4.26,1.86-6.66,1.86a12.66,12.66,0,0,1-6.39-1.6c-2.4-1.6-2.93-3.73-2.93-6.39V420.1h6.93V434a3.58,3.58,0,0,0,.53,2.4,2.89,2.89,0,0,0,2.4,1.07,3.72,3.72,0,0,0,2.4-.8,3.81,3.81,0,0,0,.8-2.93V420.1h5.33Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_6",
    "data-name": "<Path>",
    d: "M482.57,442.48h-6.39v-17h-4.8V420.1H487.1v5.33h-4.53Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.69,420.1h8.26c3.2,0,5.86.53,8.26,2.66a11.91,11.91,0,0,1,.27,16.52c-2.13,2.4-5.06,2.93-8,2.93h-8.79V420.1Zm8,17.32a7.38,7.38,0,0,0,2.4-.27,4.52,4.52,0,0,0,1.6-1.6,8.44,8.44,0,0,0,1.07-4.26,10,10,0,0,0-1.33-4.8c-1.07-1.33-2.13-1.33-3.73-1.33h-.8v12h.8Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547,431.55c0,6.39-4,11.46-10.66,11.46s-10.66-5.06-10.66-11.46c0-6.66,4-11.46,10.66-11.46C543,419.83,547,424.63,547,431.55Zm-14.12,0c0,2.13.27,6.39,3.46,6.39s3.46-4.26,3.46-6.39-.27-6.66-3.46-6.66S532.92,429.16,532.92,431.55Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.41,431.55c0,6.39-4,11.46-10.66,11.46s-10.66-5.06-10.66-11.46c0-6.66,4-11.46,10.66-11.46C573.41,419.83,577.41,424.63,577.41,431.55Zm-14.12,0c0,2.13.27,6.39,3.46,6.39s3.46-4.26,3.46-6.39-.27-6.66-3.46-6.66S563.29,429.16,563.29,431.55Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.52,442.48l-3.2-8.52h-2.13v8.52h-6.93V420.1h11.46a11.77,11.77,0,0,1,5.86,1.33,5.92,5.92,0,0,1,2.66,5.33,5.77,5.77,0,0,1-4,5.86l4,9.86Zm-2.93-13.32c1.6,0,3.2-.27,3.2-2.13a1.78,1.78,0,0,0-1.07-1.86,4.53,4.53,0,0,0-1.86-.27h-2.66v4.26Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_7",
    "data-name": "<Path>",
    d: "M621.9,435a3.79,3.79,0,0,0,4,2.66c.8,0,2.66-.27,2.66-1.33,0-1.33-1.86-1.6-2.66-1.86-4.26-.8-9.32-1.86-9.32-7.19a7,7,0,0,1,2.93-5.59,10.92,10.92,0,0,1,6.39-1.6c4,0,7.73,1.6,9.06,5.59l-5.59,1.6c-.53-1.6-1.86-2.13-3.73-2.13-.8,0-2.13.27-2.13,1.33s1.6,1.33,2.4,1.6a29,29,0,0,1,6.39,1.86,6,6,0,0,1,3.2,5.59c0,5.33-5.33,7.46-9.86,7.46-4.8,0-8.79-1.86-10.12-6.93Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.76,407.31H267.58l-5.06-16.78H236.41l-5.06,16.78H214.57L238,332.18l23.18-5.59Zm-28.5-31.44-8.52-28.5-8.52,28.5Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#0556a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_8",
    "data-name": "<Path>",
    d: "M330.45,367.35c0-3.73-2.4-7.46-8.52-7.46-9.59,0-10.66,9.32-10.66,17,0,7.19,0,17.85,10.12,17.85,6.13,0,8.79-3.73,9.32-9.32l17-.27c-1.33,14.92-12.52,23.71-27.17,23.71-18.12,0-29-12.79-29-30.64,0-18.38,11.19-31.7,30.1-31.7,13.85,0,24.78,9.06,25.84,20.78Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#0556a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.32,407.84v-9.32c-5.06,7.19-10.12,10.39-19.18,10.39-10.66,0-18.91-5.59-18.91-17,0-8.79,5.59-14.92,13.59-17.85,6.93-2.66,16.52-3.2,23.71-3.73v-1.33c0-2.66.27-5.59-1.6-8-1.6-2.13-4.53-2.93-7.19-2.93-5.59,0-10.39,3.46-10.39,9.32l-16-.27c1.6-16,15.72-20.51,28.24-20.51,6.13,0,14.12,1.33,18.91,5.33,6.13,5.06,5.59,11.46,5.59,18.91v37Zm-.8-28.77c-6.66.8-18.91,2.13-18.91,10.92,0,4.8,2.93,8,7.73,8a10.62,10.62,0,0,0,8.79-5.06c2.4-3.73,2.4-7.46,2.4-11.46v-2.4Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#0556a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.79,407.84v-9.32h-.27c-3.2,6.39-8.26,10.39-16,10.39-16.78,0-21.58-16.52-21.58-30.37,0-14.39,4.53-32,22.11-32,6.66,0,11.19,2.13,14.92,7.46V329l17.32-4v82.85Zm-.8-33.3c0-5.86-.53-15.72-8.52-15.72-9.86,0-10.39,13.05-10.39,20.25,0,6.39,1.07,17.58,9.59,17.58a8.68,8.68,0,0,0,7.46-4.8,19.85,19.85,0,0,0,1.6-8.79v-8.52Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#0556a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.42,380.67v2.93c0,7.19,4,12.79,11.72,12.79,5.33,0,10.92-4,10.92-9.59h16.25c0,2.93-5.59,21.84-27.71,21.84-17.85,0-29.57-12.52-29.57-30.37s10.39-32,29.3-32c8.52,0,17,3.73,22.11,10.66s6.39,15.45,6.13,23.44l-39.16.27Zm21-10.12c-.27-6.39-2.4-12.52-10.12-12.52s-10.66,5.59-11.19,12.52Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#0556a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_9",
    "data-name": "<Path>",
    d: "M564.89,346.3V357h.27c3.2-7.19,8.79-10.39,16.78-10.39s12.79,3.2,16.52,10.39c3.2-7.19,10.12-10.39,17.58-10.39,5.33,0,11.19,1.86,14.65,6.13,4,4.8,3.2,11.46,3.2,17.58v37.56H616.57v-31.7c0-2.4.27-8.26-.27-10.66-1.07-3.73-3.73-4.8-7.46-4.8-3.2,0-6.39,1.86-7.46,4.53-1.33,2.93-1.07,7.46-1.07,10.66v31.7H583v-31.7c0-6.39,1.07-15.45-7.73-15.45-9.06,0-8.79,9.06-8.79,15.45v31.7H549.17V350Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#0556a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_10",
    "data-name": "<Path>",
    d: "M675.44,404.11c-4.53,13.59-6.93,29.3-24,29.3h-8.52l.27-12.52h8.52c5.86,0,8-7.46,9.59-13.05L639.48,347.9h17L668,383.6l11.46-35.7h14.39Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#0556a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_11",
    "data-name": "<Path>",
    d: "M184.47,367.88c17.32,24.51,10.66,48.75-16.78,54.35-19.71,4-35.17,1.07-52.75-5.86,14.92,5.33,28.5,6.39,41.83,4.26,26.64-4,33.57-25.57,14.12-48.49-17.32-20.51-52.75-32.23-79.12-28-27.71,4.26-35.43,26.64-19.45,47.15a41.76,41.76,0,0,0,8.26,8.52,60.37,60.37,0,0,1-11.46-12c-17.58-24.78-7.46-50.35,27.17-56.21C126.12,326.86,166.62,342.57,184.47,367.88Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#ec1c24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.33,347.1s21.31,1.86,39.43,12.52l3.46,60.21s-14.92,2.93-22.91,1.33L136.78,407l-33.3,3.2L84.3,439l-27.17,3.73Zm-4,45.82L136,390.26l-1.07-32Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#0556a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_12",
    "data-name": "<Path>",
    d: "M127.72,333.25s16.78,4,28.24,10.39L154.89,325Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#0256a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.15,347.64a7.73,7.73,0,0,1,7.73,7.73,7.57,7.57,0,0,1-7.73,7.73,7.73,7.73,0,0,1-7.73-7.73,7.91,7.91,0,0,1,7.73-7.73Zm0,1.33c-3.46,0-6.13,2.93-6.13,6.66a6.54,6.54,0,0,0,6.39,6.66c3.46,0,6.13-2.93,6.13-6.66a6.54,6.54,0,0,0-6.39-6.66Zm-1.6,11.19h-1.33v-8.79c.8,0,1.33-.27,2.4-.27a5.73,5.73,0,0,1,2.66.53,2.07,2.07,0,0,1,.8,1.86,2.32,2.32,0,0,1-1.6,2.13h0c.8.27,1.33.8,1.33,2.13.27,1.33.53,1.86.53,2.13H705a3.44,3.44,0,0,1-.53-2.13,1.76,1.76,0,0,0-1.86-1.6h-1.07Zm0-4.8h1.07c1.07,0,2.13-.53,2.13-1.6,0-.8-.53-1.6-2.13-1.6h-1.07Z",
    transform: "translate(-57.13 -324.99)",
    style: {
      fill: "#0556a4"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademyLogo);
export default __webpack_public_path__ + "static/media/academy-logo.6f3df85e2af75642494b2ac72602cbf2.svg";
export { ForwardRef as ReactComponent };